// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7d46dbc0","498":"ea4d595d"}[chunkId] + ".chunk.js";
};